import { render, staticRenderFns } from "./platList.vue?vue&type=template&id=600038cd&scoped=true&"
import script from "./platList.vue?vue&type=script&lang=js&"
export * from "./platList.vue?vue&type=script&lang=js&"
import style0 from "./platList.vue?vue&type=style&index=0&id=600038cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600038cd",
  null
  
)

export default component.exports